import React from "react";

import NoLocationFound from "../../../Icons/NoData/NoLocationFound";

const NoRunningLateDataFound = () => {
  return (
    <div className="mt-4 grid items-center justify-center p-12">
      <div className="grid w-full justify-center gap-2 text-center">
        <div className="justify-self-center">
          <NoLocationFound />
        </div>
        <div>
          <p className="mt-5 text-[18px] font-semibold leading-[normal] text-primary">
            Oops Location is not available !!
          </p>
        </div>
        <div>
          <p className="mt-2 text-center text-[14px] font-semibold leading-[normal] text-txtColor">
            We apologize for the inconvenience. It seems Location is not shared
            by the candidate.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoRunningLateDataFound;
